import React from 'react';
import { Field as FinalField, FieldMetaState } from 'react-final-form';
import { SxProps } from '@mui/system';
import { TextFieldProps } from '@mui/material';
import isEmpty from 'lodash/isEmpty';
import toNumber from 'lodash/toNumber';
import TextFieldStyled from './styled';

interface Props extends Pick<TextFieldProps, 'placeholder' | 'slotProps' | 'size'> {
  name: string;
  label?: string;
  sx?: SxProps;
  parse?: ((value: any, name: string) => any) | undefined;
  format?: ((value: any, name: string) => any) | undefined;
  multiline?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
  formatOnBlur?: boolean;
  noHelperText?: boolean;
  type?: string;
  isEqual?: (prev: any, next: any) => boolean;
  validate?: (value?: any, allValues?: Object, meta?: FieldMetaState<any>) => any;
}
const identity = (value) => value;
const numberParse = (value) => (isEmpty(value) ? null : toNumber(value));

export default function RFFTextInput(props: Props) {
  const { name, validate, formatOnBlur, helperText, type, parse = identity, format, noHelperText = false, ...rest } = props;
  return (
    <FinalField allowNull name={name} validate={validate} formatOnBlur={formatOnBlur} parse={type === 'number' ? numberParse : parse} format={format}>
      {({ input, meta }) => {
        const hasError = meta.touched && meta.error;
        return (
          <TextFieldStyled {...rest} {...input} fullWidth helperText={noHelperText ? null : hasError || helperText} error={!!hasError} type={type} />
        );
      }}
    </FinalField>
  );
}
